import React, {Component, useState} from 'react';
import {compose} from "redux";
import {firestoreConnect, useFirestore, useFirestoreConnect, useFirebaseConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {useSelector} from 'react-redux'

import {CALL_DB_PATH, COMPANY_DB_PATH} from "../constants/DB_PATHS";
import {SUBSCRIBED} from "../utils/subsciptionStatus";

const STEPS = 2

function PrevPage({endBefore = 0}) {
    useFirestoreConnect([
        {
            collection: CALL_DB_PATH,
            orderBy: [
                ['callDate', 'desc'],
            ],
            //limit: 2,

            endBefore: endBefore,
        }
    ])
    const calls = useSelector(({firestore}) =>
        firestore.ordered[CALL_DB_PATH]
    )
    if (calls && calls.length !== 0) {
        console.log(calls)
        return (
            <div>
                <h3>Prev</h3>
                {Object.entries(calls).map((e, i) => {
                    return (
                        <div key={i}>{e[1].id}</div>
                    )
                })}
            </div>
        )

    } else {
        return (
            <div>
                Loadini...g
            </div>
        )
    }
}


function NextPage({startAfter = 0}) {
    //const [lastDoc, setLastDoc] = useState(0)
    //const [startAfter, setStartAfter] = useState(0)
    const [endBefore, setEndBefore] = useState('')

    useFirestoreConnect([
        {
            collection: CALL_DB_PATH,
            orderBy: [
                ['callDate', 'desc'],
            ],
            //endBefore: endBefore.callDate,
            startAfter: startAfter,

            limit: 2,

        }
    ])

    const calls = useSelector(({firestore}) =>
        firestore.ordered[CALL_DB_PATH]
    )
    //console.log('startafter:',startAfter.id || '')
    //console.log('endbefore:',endBefore.id || '')
    if (calls && calls.length !== 0) {
        console.log(calls)
        return (
            <div>
                <h3>Next</h3>
                {Object.entries(calls).map((e, i) => {
                    return (
                        <div key={i}>{e[1].id}</div>
                    )
                })}
            </div>
        )

    } else {
        return (
            <div>
                Loadini...g
            </div>
        )
    }
}

class TestList extends Component {
    constructor() {
        super();
        this.state = {
            nextPage: true,
            startAfter: 0,
            endBefore: 0,
        }
    }

    render() {
        const {calls} = this.props
        console.log(this.props)
        return (
            <div>
                <button onClick={() => {
                    if (calls) {
                        console.log(calls[0])
                        this.setState({
                            nextPage: false,
                            endBefore: calls[0].callDate
                        })
                    }
                }}>Prev
                </button>
                <button onClick={() => {
                    if (calls) {
                        console.log(calls[calls.length - 1])
                        this.setState({
                            nextPage: true,
                            startAfter: calls[calls.length - 1].callDate
                        })
                    }

                }}>Next
                </button>

                {/* <button onClick={() => {
                    this.setState({pageNum: this.state.pageNum + 1})
                }}>next
                </button>*/}

            </div>
        );
    }
}


export default compose(
    firestoreConnect(state => {
        return [
            {
                collection: COMPANY_DB_PATH,
                where: [
                    ['subscriptionStatus', '==', SUBSCRIBED]
                ],
                storeAs: 'coms',

            },
        ]
    }),
    connect(({firestore}) => ({
            co: firestore.ordered.coms
        })
    ),
)(TestList)